import type { User } from 'firebase/auth'

const CMS_URL = import.meta.env.VITE_CMS_URL ?? 'https://doublebagel.co'

/**
 * Exchanges a Firebase ID token for a CMS session cookie.
 * Fire-and-forget — never throws, never blocks the auth flow.
 */
export async function syncSessionToCMS(user: User): Promise<void> {
  try {
    const idToken = await user.getIdToken()
    const res = await fetch(`${CMS_URL}/api/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ idToken }),
    })
    if (!res.ok) console.warn('[syncSessionToCMS] failed:', res.status)
  } catch (err) {
    console.warn('[syncSessionToCMS] error:', err)
  }
}

/**
 * Clears the CMS session cookie on logout.
 * Fire-and-forget — never throws.
 */
export async function clearCMSSession(): Promise<void> {
  try {
    await fetch(`${CMS_URL}/api/session`, {
      method: 'DELETE',
      credentials: 'include',
    })
  } catch {
    // Non-blocking
  }
}
